import React from 'react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';

export default function CustomerFilters({
  searchTerm, setSearchTerm,
  typeFilter, setTypeFilter,
  statusFilter, setStatusFilter,
}) {
  return (
    <Card className="p-4 mb-6">
      <div className="flex flex-wrap items-end gap-4">
        <div className="flex-1 min-w-[200px]">
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            <Search className="w-3 h-3 inline mr-1" />
            Search
          </Label>
          <Input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search by name, phone, or email..."
            className="w-full"
            data-testid="customer-search"
          />
        </div>

        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            Customer Type
          </Label>
          <div className="flex gap-2">
            {['all', 'registered', 'guest'].map(type => (
              <Button
                key={type}
                variant={typeFilter === type ? 'default' : 'outline'}
                size="sm"
                onClick={() => setTypeFilter(type)}
                className="capitalize"
              >
                {type === 'all' ? 'All' : type}
              </Button>
            ))}
          </div>
        </div>

        {/* Activation status filter — All / Active / Inactive. Implicitly
            hides guests when Active/Inactive is selected (they have no
            account_status field). */}
        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            Status
          </Label>
          <div className="flex gap-2" data-testid="customer-status-filter">
            {[
              { v: 'all',      label: 'All' },
              { v: 'active',   label: 'Active' },
              { v: 'inactive', label: 'Inactive' },
            ].map(opt => (
              <Button
                key={opt.v}
                variant={statusFilter === opt.v ? 'default' : 'outline'}
                size="sm"
                onClick={() => setStatusFilter(opt.v)}
                data-testid={`status-filter-${opt.v}`}
              >
                {opt.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
}
